import { render, staticRenderFns } from "./ProductConSwiper.vue?vue&type=template&id=6a4c83c4&scoped=true&"
import script from "./ProductConSwiper.vue?vue&type=script&lang=js&"
export * from "./ProductConSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ProductConSwiper.vue?vue&type=style&index=0&id=6a4c83c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c83c4",
  null
  
)

export default component.exports